// Sample data only — Campaign Builder mockup.
export const COHORT = {
  households: 1284, multi: 312, multiPct: 24, dogsInMulti: 668,
  boardedLastYear: 188, notBookedHoliday: 121, roomNightsUpside: 540, revenueUpside: 48600,
  split: [["2 dogs", 251], ["3 dogs", 49], ["4+ dogs", 12]],
};

export const PRIORITY = [
  { k: "multi_board", label: "Multi-dog boarders", sub: "2+ active dogs · share a room" },
  { k: "single_board", label: "Single-dog boarders", sub: "1 dog · boarded before" },
  { k: "daycare_only", label: "Daycare-only", sub: "never boarded · warm leads" },
  { k: "private_play", label: "Private Play", sub: "extra labor · contact last" },
];

export const TEMPLATES = [
  { k: "thanksgiving", name: "Thanksgiving comeback", desc: "Boarded last Thanksgiving, visited since, not booked this year", count: 86 },
  { k: "multi_holiday", name: "Multi-dog holiday push", desc: "2+ active dogs, no holiday booking yet", count: 121 },
  { k: "lapsed_boarders", name: "Lapsed boarders (90d)", desc: "Boarded in the last year, no stay in 90 days", count: 64 },
  { k: "daycare_to_board", name: "Daycare → first boarding", desc: "Daycare 2x/week+, never boarded", count: 57 },
];

export const CAMPAIGNS = [
  { id: "c1", name: "Thanksgiving comeback 2026", status: "Active", audience: 86, sent: 54, booked: 17, revenue: 9820, refreshed: "Today 8:02 AM" },
  { id: "c2", name: "Multi-dog holiday push", status: "Draft", audience: 121, sent: 0, booked: 0, revenue: 0, refreshed: "Yesterday 4:40 PM" },
  { id: "c3", name: "Summer lapsed boarders", status: "Done", audience: 64, sent: 61, booked: 12, revenue: 6140, refreshed: "Aug 3" },
];

const N = [
  ["Catherine", "Moss", ["Yardley", "Biscuit"], "multi_board", "Thanksgiving 2025 · 4 nights", "Oct 12 daycare"],
  ["Mary", "Lee", ["Nami", "Kobe"], "multi_board", "Thanksgiving 2025 · 3 nights", "Oct 18 bath"],
  ["James", "Ortiz", ["Rex", "Luna", "Milo"], "multi_board", "Thanksgiving 2025 · 5 nights", "Sep 29 boarding"],
  ["Priya", "Shah", ["Coco", "Bean"], "multi_board", "Thanksgiving 2025 · 2 nights", "Oct 20 daycare"],
  ["Tom", "Becker", ["Archie"], "single_board", "Thanksgiving 2025 · 4 nights", "Oct 02 daycare"],
  ["Lena", "Park", ["Mochi"], "single_board", "Thanksgiving 2025 · 3 nights", "Oct 15 boarding"],
  ["Dan", "Rossi", ["Bruno"], "daycare_only", "Daycare 3x/week", "Oct 22 daycare"],
  ["Sara", "Kim", ["Pip"], "private_play", "Thanksgiving 2025 · 2 nights", "Oct 09 private play"],
];

// sms_ok / email_ok mirror Gingr's owner profile opt-ins ("Text message", "Email" checkboxes).
const OPT = [[1, 1], [1, 1], [1, 0], [1, 1], [0, 1], [1, 1], [1, 0], [1, 1]];

export const AUDIENCE = N.map(([first, last, dogs, tier, history, recent], i) => ({
  id: `o${i + 1}`, first, last, dogs, tier, history, recent,
  ltv: [4200, 3880, 6120, 2950, 1980, 2210, 1450, 1720][i],
  sms_ok: !!OPT[i][0], email_ok: !!OPT[i][1],
}));

export const LOC = { name: "K9 Resorts Chalfont", phone: "267-915-2070", book: "k9chalfont.portal.gingrapp.com", suitesLeft: 6, dates: "Nov 26–30" };

const petsOf = (c) => (c.dogs.length > 1 ? `${c.dogs.slice(0, -1).join(", ")} & ${c.dogs.at(-1)}` : c.dogs[0]);

export const smsFor = (c) => {
  const pets = petsOf(c), suite = c.dogs.length > 1 ? "a shared suite" : "a suite";
  return `Hi ${c.first}, it's ${LOC.name}! We loved having ${pets} last Thanksgiving. Only ${LOC.suitesLeft} holiday suites left for ${LOC.dates}. Reply YES and we'll hold ${suite} for ${pets}, or book at ${LOC.book} / call ${LOC.phone}.`;
};

export const emailFor = (c) => {
  const pets = petsOf(c);
  return {
    subject: `${pets}'s Thanksgiving suite: only ${LOC.suitesLeft} left`,
    body: `Hi ${c.first},\n\nWe loved having ${pets} with us last Thanksgiving! Holiday suites for ${LOC.dates} are going fast, and we have just ${LOC.suitesLeft} left.\n\nBook in a minute: https://${LOC.book}\nOr call us: ${LOC.phone}\n\n${LOC.name}`,
  };
};
